<template>
  <base-open-savings-deposit-modal
    :isVisible="openSavingDepositModal.isVisible"
    :showIcon="!openSavingDepositModal.showConfirmation"
    :title="modalTitle"
    :text="modalText"
    :onCancelLabel="skipButtonLabel"
    :onSubmitLabel="continueButtonLabel"
    :onCancelFn="initiateSkip"
    :onSubmitFn="onContinue"
  />
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { useRootStore } from '@/store/root'
import LogoutReason from '@/types/logout-reason'
import BaseOpenSavingsDepositModal from './BaseOpenSavingsDepositModal.vue'
import api from '@/api'

export default {
  components: {
    BaseOpenSavingsDepositModal
  },
  computed: {
    ...mapState(useRootStore, ['openSavingDepositModal', 'isCompany', 'featureFlags']),
    translations () {
      const translations = {
        modalTitle: this.isCompany
          ? this.$pgettext('corporate_open_savings_deposit_modal', 'Create your first saving deposit')
          : this.$pgettext('open_savings_deposit_modal', 'Create your first saving deposit'),
        confirmLogoutModalTitle: this.$pgettext('open_savings_deposit_modal', 'Are you sure you want to close process?'),
        modalText: this.isCompany
          ? this.$pgettext('corporate_open_savings_deposit_modal', 'In order to continue using corporate Self-service please, proceed with opening of savings deposit account')
          : this.$pgettext('open_savings_deposit_modal', 'In order to continue using Self-service please, proceed with opening of savings deposit account'),
        confirmLogoutModalText: this.$pgettext('open_savings_deposit_modal', 'If you will cancel deposit creation process all you progress will not be saved and we would log out from your account.'),
        createDeposit: this.$pgettext('open_savings_deposit_modal', 'Create deposit'),
        continue: this.$pgettext('open_savings_deposit_modal', 'Continue process'),
        skip: this.$pgettext('open_savings_deposit_modal', 'Skip'),
        logout: this.$pgettext('open_savings_deposit_modal', 'Log out')
      }

      return translations
    },
    modalTitle () {
      return this.openSavingDepositModal.showConfirmation ? this.translations.confirmLogoutModalTitle : this.translations.modalTitle
    },
    modalText () {
      return this.openSavingDepositModal.showConfirmation ? this.translations.confirmLogoutModalText : this.translations.modalText
    },
    skipButtonLabel () {
      return this.featureFlags.enableSavingsDepositOptionalOffer ? this.translations.skip : this.translations.logout
    },
    continueButtonLabel () {
      return this.openSavingDepositModal.showConfirmation ? this.translations.continue : this.translations.createDeposit
    }
  },
  methods: {
    ...mapActions(useRootStore, ['hideOpenSavingsDepositErrorModal']),
    async initiateSkip () {
      const canBeSkipped = this.featureFlags.enableSavingsDepositOptionalOffer

      if (!canBeSkipped) {
        this.initiateLogout()
        return
      }

      await this.onContinue()
      this.$router.push({ path: '/' })
    },
    initiateLogout () {
      this.$router.push({ path: '/logout', query: { reason: LogoutReason.OPEN_SAVINGS_DEPOSIT_MODAL } })
    },
    async onContinue () {
      this.hideOpenSavingsDepositErrorModal()
      await api.increaseHasSeenMandatoryOpenSavingsDepositModal()
    }
  }
}
</script>
